import React from "react";
import SidebarNav from "../../components/SidebarNav/SidebarNav";
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";
import apiProviderMenuItems from "../../helpers/menus/apiProviderSideBarMenu.json"


const BecomeApiProviderTemplate = ({ children, crumb, hideSidebar, overrideClasses }) => {
    const childrenArray = React.Children.toArray(children)
    const firstChild = childrenArray[0];
    const blueBackgroundElements = childrenArray.slice(1)
  
    return (
      <div>
        <PrimaryNav />
        {/* <Breadcrumbs crumbs={breadcrumbs} /> */}
        <main className="p-10-40">
          <div className={`${overrideClasses ? overrideClasses : "grid-row grid-gap padding-bottom-5 padding-x-2"}`}>
            {!hideSidebar && <SidebarNav menuItems={apiProviderMenuItems} />}
            <div className={hideSidebar ? "" : "tablet:grid-col-8"}>
              { firstChild }
            </div>
          </div>
          { blueBackgroundElements.length > 0 && <div className="grid-row grid-gap padding-bottom-5 padding-x-2">
            { blueBackgroundElements }
          </div>}
        </main>
      </div>
    );
  }
  export default BecomeApiProviderTemplate
